{/* Auto-generated icon - do not edit */}
import React from 'react'

interface FemaileIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const FemaileIcon = React.forwardRef<SVGSVGElement, FemaileIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 78 125"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M44.4276 77.1558C44.6822 82.9493 44.9265 88.5013 45.1864 94.4208C48.3369 94.1045 51.1079 93.8045 53.8829 93.5571C55.1013 93.3976 56.3319 93.3543 57.5585 93.4258C59.3962 93.6122 60.7029 94.6026 61.0238 96.5388C61.1733 97.4393 60.9883 98.3634 60.5037 99.1373C60.019 99.9111 59.2683 100.481 58.3927 100.739C56.9912 101.122 55.5437 101.311 54.0909 101.301C51.4137 101.384 48.7312 101.325 45.8079 101.325C45.8079 102.677 45.768 103.749 45.8146 104.818C45.9958 108.967 46.274 113.113 46.3619 117.263C46.369 118.712 46.1411 120.153 45.6877 121.529C45.4897 122.304 45.0252 122.985 44.3757 123.452C43.7261 123.919 42.9331 124.143 42.1352 124.084C41.3952 124.072 40.678 123.825 40.0873 123.38C39.4966 122.934 39.0627 122.312 38.8487 121.604C38.4122 120.455 38.141 119.25 38.0433 118.025C37.7657 113.77 37.5977 109.507 37.412 105.246C37.3641 104.145 37.4055 103.041 37.4055 101.425C35.938 101.425 34.7559 101.463 33.5771 101.417C30.8861 101.315 28.1793 101.322 25.5133 100.998C23.4465 100.747 22.3853 99.3309 22.4601 97.6047C22.5375 95.8076 23.6047 94.8645 25.9386 94.8179C29.517 94.747 33.0981 94.7995 37.0479 94.7995C37.2553 88.9765 37.4535 83.4232 37.6649 77.5109C36.4572 77.3659 35.1642 77.1545 33.8627 77.0626C16.4573 75.8353 5.39984 64.9858 1.81623 48.5006C0.561921 43.1308 0.40751 37.5627 1.36212 32.1316C2.31672 26.7005 4.36052 21.5189 7.37074 16.8986C8.52852 15.1055 9.9405 13.4898 11.5622 12.1021C18.1778 6.28496 26.4383 2.6692 35.2001 1.75511C44.7202 0.687901 53.7903 1.96418 62.0372 7.04555C66.2377 9.63614 69.0101 13.7037 71.3768 17.9056C79.2384 31.8659 79.3008 46.1935 72.4447 60.4662C68.082 69.5495 60.1534 74.1419 50.5118 76.0637C48.6439 76.4326 46.7661 76.7371 44.4276 77.1558ZM34.5216 9.29051C30.109 8.68143 24.9948 11.1867 20.0165 14.0752C16.201 16.273 13.1013 19.526 11.0902 23.4431C5.62029 33.8323 6.54047 44.2608 10.8579 54.633C14.3522 63.0295 20.8344 68.0026 29.7324 69.7576C37.8598 71.3591 45.8395 70.5203 53.623 67.8687C58.4957 66.2094 62.3955 63.0898 64.5955 58.4488C70.8832 45.1862 70.4704 32.1986 62.1711 19.8201C60.2341 16.7548 57.4464 14.3197 54.1486 12.8122C48.4161 10.3339 42.4049 9.13863 34.5216 9.28762V9.29051Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="77.4479" height="123.392" fill={color} transform="translate(0.421875 0.941895)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

FemaileIcon.displayName = 'FemaileIcon'
